const init_header = require('./parts/_header');
const init_anchor = require('./parts/_anchor');
const init_scroll_to_top = require('./parts/_scroll-to-top');
const init_login_popup = require('./parts/_login-popup');
const init_media_kit_archive = require('./parts/_media_kit_archive');
const init_media_kit_single = require('./parts/_media_kit_single');

function initialize_all() {
  init_header();
  init_anchor();
  init_scroll_to_top();
  init_login_popup();
  init_media_kit_archive();
  init_media_kit_single();
}

if (document.readyState !== 'loading') {
  initialize_all();
} else {
  document.addEventListener('DOMContentLoaded', initialize_all);
}


